import { render, staticRenderFns } from "./ProfileUpdate.vue?vue&type=template&id=276c2d42"
import script from "./ProfileUpdate.vue?vue&type=script&lang=js"
export * from "./ProfileUpdate.vue?vue&type=script&lang=js"
import style0 from "./ProfileUpdate.vue?vue&type=style&index=0&id=276c2d42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports